import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { StorageFindManyQueryInterface } from '@zaoblako/shared/modules/storage/dtos/storage/storage-find-many-query.dto';
import type { StoragePageInterface } from '@zaoblako/shared/modules/storage/dtos/storage/storage-page.dto';

import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageService extends BaseService {
  protected baseUrl = '/basis/storage/storage';

  public findMany(query?: StorageFindManyQueryInterface): Observable<StoragePageInterface> {
    return this.http.get<StoragePageInterface>(this.baseUrl, {
      params: query ? this.objectToHttpParams(query) : {}
    });
  }
}
